import React from "react";
import _ from "lodash";
import moment from "moment"

const AllAPCMPatientsEngagement = ({ data }) => {
  let last_engagement_ts = "-";
  let call_scheduled_ts = "";
  let last_clinical_call_ts = "-";
  let last_outbound_attempt_type = "-"
  let callAttempt = "";
  let ce_flag = false;
  let targetDate = "";
  let daysAgo = "";
  if (data.activeUser && data.activeUser.center && data.activeUser.center.company_id) {
    ce_flag = data.activeUser.center.ce_flag;
}

  if(data.call_scheduled_ts){
    call_scheduled_ts = moment(data.call_scheduled_ts, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mm a');
  }

  callAttempt = !ce_flag ? (data.call_attempts ? data.call_attempts : " - " ):
    ( data.call_count ? data.call_count : " - ");

  if(data.call_due_date){
    targetDate = moment(data.call_due_date).format('MM/DD/YYYY')   
  }      
  
  if(data.last_clinical_call_ts){
    last_clinical_call_ts = moment(data.last_clinical_call_ts).format('MM/DD/YYYY')  
    daysAgo = moment(data.last_clinical_call_ts).fromNow()
  }

  if(data.last_outbound_attempt_type){
    last_outbound_attempt_type = data.last_outbound_attempt_type  
  }
  
  return (
    <div>
      <div
        className="value-box"
        style={{
          width: "100%",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          padding: 0,
        }}
      >
        {
          call_scheduled_ts &&  <div
            style={{ display: "flex", justifyContent: "flex-start", padding: 0 }}
          >
            <span style={{ fontWeight: 600 }}>Scheduled Call:</span>
            <span style={{ paddingLeft: 15 }}>
              {call_scheduled_ts}
            </span>
          </div>
        }
       {
        callAttempt && <div
          style={{ display: "flex", justifyContent: "flex-start", padding: 0 }}
        >
          <span style={{ fontWeight: 400 }}>Call Attempts:</span>
          <span style={{ paddingLeft: 15 }}>
            {callAttempt}
          </span>
        </div>
       }
        <div
          style={{ display: "flex", justifyContent: "flex-start", padding: 0 }}
        >
          <span style={{ fontWeight: 400 }}>Last Call:</span>
          <span style={{ paddingLeft: 15 }}>
            {last_clinical_call_ts} {daysAgo ? ("("+daysAgo+")") :""}
          </span>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-start", padding: 0 }}
        >
          <span style={{ fontWeight: 400 }}>Target Date:</span>
          <span style={{ paddingLeft: 15 }}>
            {targetDate}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AllAPCMPatientsEngagement;
